import { useTranslation } from 'react-i18next';
import { ExternalImage } from '@shared/ui/image';
import {
  SmartLink,
  useLoaderData,
  useRouteLoaderData,
} from '@shared/lib/routing';
import { Breadcrumbs } from '@shared/ui/breadcrumbs';
import { PageContainer } from '@shared/ui/content-containers';
import { PageTitle } from '@shared/ui/titles';
import {
  ISeoPage,
  PageBanner,
  PageHelmet,
  PageCustomText,
} from '@widgets/seoPage';
import { Preloader } from '@shared/ui/preloader';
import { CatalogGrid } from '@shared/ui/catalog-grid';

export function Menu() {
  const { t } = useTranslation();
  const { pageData, loading } = useLoaderData<{
    seoPageData: ISeoPage;
  }>();
  const { country, city, menu } = useRouteLoaderData('city-layout');

  if (loading) {
    return <Preloader />;
  }
  const { seoPageData } = pageData;
  return (
    <>
      <PageBanner
        bannerData={seoPageData.banner}
        mainDomain={country.main_domain}
      />
      <PageContainer>
        <PageHelmet
          cityName={city.city_name}
          seo={seoPageData.seo}
          title={t('localization.Menu')}
          mainDomain={country.main_domain}
        />
        <Breadcrumbs
          links={[
            {
              text: t('localization.Menu'),
            },
          ]}
        />
        <PageTitle isCenterOnMobile>{t('localization.Menu')}</PageTitle>
        <CatalogGrid maxInRow="4">
          {menu
            .filter(({ visible }) => !!visible)
            .map((item) => {
              const imgProps = {
                mainDomain: country.main_domain,
                alt: item.title,
              };
              return (
                <li
                  key={item.id}
                  // TODO: перенести стили в отдельную переиспользуемую карточку
                  className="group relative flex items-center justify-center overflow-hidden rounded-xl"
                >
                  <SmartLink href={`/menu/${item.text_id}`}>
                    <ExternalImage
                      src={item.images_mobile?.[0]?.filename}
                      width={549}
                      height={347}
                      wrapperClassName="flex! lg:hidden!"
                      {...imgProps}
                    />
                    <ExternalImage
                      src={item.images_desktop?.[0]?.filename}
                      width={400}
                      height={320}
                      wrapperClassName="hidden! lg:flex!"
                      {...imgProps}
                    />
                    {/* // TODO: перенести стили в отдельную переиспользуемую карточку */}
                    <span
                      className="transition-translate absolute -bottom-8 left-0 w-full bg-white/95 py-1 pb-9
                        text-center text-lg font-light text-(--black) duration-200 ease-in
                        group-hover:-translate-y-8 sm:text-xl lg:text-2xl 2xl:text-3xl"
                    >
                      {item.title}
                    </span>
                  </SmartLink>
                </li>
              );
            })}
        </CatalogGrid>
        <PageCustomText
          customText={seoPageData.seo.custom_text}
          mainDomain={country.main_domain}
        />
      </PageContainer>
    </>
  );
}
